class WLCartNovelty extends HTMLElement {
  constructor() {
    super();
    this.cartBtn = document.getElementById('novelty');
    this.target = document.getElementById('wl-novelty');
    this.removeTarget = document.querySelector('#removeNoveltyItem')
    document.addEventListener('DOMContentLoaded', () => {
      const list = this.querySelectorAll('ul li')
      if (list.length === 0) {
        this.style.display = 'none'
      } else {
        this.style.display = 'block'
      }
    })
    this.removeEvt(this.removeTarget)
    this.onClickEvt()
  }
  getSectionsToRender() {
    return [
      {
        id: 'wl-novelty',
        section: document.getElementById('wl-novelty').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }
  async removeEvt(removeTarget){
    const target = JSON.parse(this.removeTarget.textContent)
    const update = {
      'updates': target,
      'sections': this.getSectionsToRender().map((section) => section.section),
      'sections_url': window.location.pathname
    }

    // All in giftの設定
    const allInGiftSetting = window.localStorage.getItem("allInGift")
    if(allInGiftSetting && allInGiftSetting !== "undefined") {
      update["attributes"] = JSON.parse(allInGiftSetting);

      // カート画面の手提げを非表示
      document.getElementsByClassName('js-cdd-container')[0].style.display = 'none';

      // カート画面の配送先日時指定を非表示
      document.getElementById('cart-delivery-datetime_section_os2').style.display = 'none';
    }
    
    const parsedState = await this.fetchEvt(update)
    this.getSectionsToRender().forEach((section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  async addNoveltyEvt(target) {
    const update = {
      'updates': {}
    }
    
    for(let i = 0;i < target.length; i++) {
      update.updates[target[i].value] = 1
    }

    if(Object.keys(update.updates).length > 0) {
      return await this.fetchEvt(update)
    }
    return true
  }

  onClickEvt() {
    document.querySelector('body').addEventListener('click', (event) => {
      if (event.target.id === 'novelty') {
        this.handleClickEvt();
      }
    });
  }

  async handleClickEvt() {
    const items = document.querySelectorAll('.novelty-item:checked');
    await this.addNoveltyEvt(items);
    document.querySelector('#checkout').click();
  }

  fetchEvt(update){
    return new Promise((resolve, reject) => {
      fetch(Shopify.routes.root + 'cart/update.js', {
        'method': 'POST',
        'headers': {
          'Content-type': 'application/json'
        },
        'body': JSON.stringify(update)
      })
      .then(res => res.json())
      .then(res => {
        resolve(res)
      })
      .catch(error => reject(error))
    })
  }
}
customElements.define('wl-novelty', WLCartNovelty);